// Module
var code = "<template>\n    <span show.bind=\"visible\">\n        <slot>\n        </slot>\n    </span>\n</template>\n";
// Exports
export default code;